<template>
  <div v-if="customisations">
    <div :style="{ backgroundImage: 'url(' + customisations.bg_image + ')' }" class="login-bg"></div>
    <div class="login-container"></div>
    <div :style="{ background: customisations.bg_color }" class="login-form">
      <template v-if="!new_password_required">
        <div class="login-header">
          <img :alt="customisations.agency_name" :src="customisations.image" class="login-logo" />
          <div class="login-title">LOG IN</div>
          <div class="login-sub-title">
            TO MANAGE
            <strong>{{ customisations.site_name }}</strong>
          </div>
        </div>
        <div class="login-input">
          <i class="fa fa-user"></i>
          <input
            @keyup.enter="logIn"
            class="txt txt-login"
            placeholder="Username / Email"
            type="text"
            v-model="username"
          />
        </div>
        <div class="login-input">
          <i class="fa fa-lock"></i>
          <input @keyup.enter="logIn" class="txt txt-login" placeholder="Password" type="password" v-model="password" />
        </div>
        <button @click="logIn" class="btn btn-login" type="button">
          <span v-show="!logging_in">Login</span>
          <i class="fa fa-circle-o-notch fa-spin" v-show="logging_in" />
        </button>
      </template>
      <template v-if="new_password_required">
        <p class="login-message">
          Your temporary password has expired.
          <br />Please choose a new password:
        </p>
        <div class="login-input">
          <input
            @keyup.enter="setNewPassword"
            class="txt txt-login"
            placeholder="New password"
            type="password"
            v-model="new_password"
          />
        </div>
        <div class="login-input">
          <input
            @keyup.enter="setNewPassword"
            class="txt txt-login"
            placeholder="Confirm new password"
            type="password"
            v-model="confirm_new_password"
          />
        </div>
        <div class="login-actions">
          <input @click="setNewPassword" class="btn btn-login" type="button" value="OK" />
          <input @click="cancelNewPassword" class="btn btn-cancel" type="button" value="Cancel" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import cognito from "@/services/cognito"

export default {
  name: "LogIn",
  data: function() {
    return {
      username: "",
      password: "",
      new_password: "",
      confirm_new_password: "",
      logging_in: false
    }
  },
  computed: {
    new_password_required: function() {
      return this.$store.state.new_password
    },
    customisations: function() {
      return this.$store.state.customisations
    }
  },
  methods: {
    logIn() {
      this.logging_in = true
      cognito.logIn(this.username, this.password.trim()).catch(() => {
        this.$nextTick().then(() => (this.logging_in = false))
      })
    },
    setNewPassword() {
      if (this.new_password != this.confirm_new_password) {
        this.$store.dispatch({
          type: "setError",
          message: "Passwords do not match"
        })
      } else {
        cognito.setNewPassword(this.new_password)
      }
    },
    cancelNewPassword() {
      this.$store.commit("CLEAR_NEW_PASSWORD")
    }
  }
}
</script>
